import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/wpexplorer': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M512 256c0 141.2-114.7 256-256 256-141.2 0-256-114.7-256-256s114.7-256 256-256 256 114.7 256 256zM480 256c0-123.2-100.3-224-224-224-123.5 0-224 100.5-224 224s100.5 224 224 224 224-100.5 224-224zM160.9 124.6l86.9 37.1-37.1 86.9-86.9-37.1zM270.9 293.7l46.6 94h-14.6l-50-100-48.9 100h-14l51.1-106.9-22.3-9.4 6-14 68.6 29.1-6 14.3zM259.1 177.4l68.6 29.4-29.4 68.3-68.3-29.1zM339.4 220.3l54.6 23.1-23.4 54.3-54.3-23.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/wpexplorer.js
// module id = 1102
// module chunks = 0